import React, {useEffect, useRef, useState} from 'react'
import {Box, Button, Divider, Grid} from '@mui/material'
import {useCartContext} from '../../../context/CartContext';
import CCOHeadline from '../../fundamentals/CCOHeadline';
import P015CartItem from './P015CartItem';
import CCOContainer from '../../fundamentals/CCOContainer';
import {useRouter} from 'next/router';
import {useTranslation} from 'react-i18next';
import P015CartSum from './P015CartSum';
import {CmLinkable} from "../../../../packages/graphql-layer/src";
import {isPageWithHiddenNavi} from "../../page_layouts/pageLayoutsUtils";
import Breadcrumb from "../../layouts/navigation/Breadcrumb";
import CCOComponentWrapper from "../../fundamentals/CCOComponentWrapper";
import CCOBackButton from "../../fundamentals/CCOBackButton";
import styles from "../../../common/constants/accessibility.module.css";


interface Props {
    page?: CmLinkable
    pageSettings?: any
}

function P015Cart(props: Props) {
    const {t} = useTranslation();
    const router = useRouter();
    const cartContext = useCartContext();
    const pathnameRef = useRef<string | null>(null);

    useEffect(() => {
        pathnameRef.current = window.location.pathname;
    })

    const [areCartItemsReady, setAreCartItemsReady] = useState(false);

    useEffect(() => {
        if (cartContext.getCartItems()) {
            setAreCartItemsReady(true);
        }
    }, [cartContext.getCartItems]);

    function handleOrderNow() {
        const forwardUrl = pathnameRef.current ? pathnameRef.current.concat('/bestellung') : '';
        router.push(forwardUrl).then(() => {
        });
    }

    return (<React.Fragment>
            {props.page && !isPageWithHiddenNavi(props.page) && <Breadcrumb target={props.page}/>}
            <CCOComponentWrapper customStyle={{mb: 'unset'}} id='main'>
                <CCOHeadline headline={t('cart.headline')!}
                             margin={{b: '16px'}}
                />
                <CCOContainer dataCypress={'cartContainer'}>
                    <Box sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '32px',
                        alignItems: 'center',
                    }}>
                        <Box sx={{
                            width: '100%',
                        }}>
                            {!cartContext.isCartFilled &&
                                <CCOHeadline headline={t('cart.empty_headline')} type={"h4"} justify={"center"}/>}

                            {areCartItemsReady && (<Grid container
                                                         sx={{alignContent: 'top', gap: '24px'}}>
                                {cartContext.getCartItems()?.map((cartItem, index, array) => (
                                    <React.Fragment key={index}>
                                        <P015CartItem item={cartItem}
                                                      key={cartItem.sosPublication.id}
                                                      pageSettings={props.pageSettings}/>
                                        {index < array.length - 1 &&
                                            <Divider flexItem orientation={'horizontal'} sx={{width: '100%'}}/>}
                                    </React.Fragment>
                                ))}
                            </Grid>)}
                        </Box>
                        {areCartItemsReady &&
                            <React.Fragment>
                                {cartContext.isCartFilled && <P015CartSum/>}
                                <Box sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'center',
                                    width: '100%',
                                }}>
                                    <Box sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '24px',
                                        alignItems: 'center',
                                    }}>
                                        {cartContext.isCartFilled &&
                                            <Box>
                                                <Button data-cypress='orderButton'
                                                    onClick={handleOrderNow}
                                                    variant='contained'
                                                    sx={{
                                                        padding: '8px 22px',
                                                    }}>
                                                {t('cart.order_now')!}
                                                </Button>
                                            </Box>
                                        }
                                        <CCOBackButton buttonLabelKey='cart.back_to_overview'
                                                       backUri={props.pageSettings?.backUri}
                                                       customStyle={{padding: '8px 22px'}}/>
                                    </Box>
                                </Box>
                            </React.Fragment>
                        }
                    </Box>
                </CCOContainer>
            </CCOComponentWrapper>
        </React.Fragment>
    )
}

export default P015Cart